import { HavenUILogger, UIConfig, UILogger } from '@hit/logger/dist/lib/ui-logger';
import { version } from '../../../../package.json';
import { CPLogger } from './CPLogger';
import { LoggerSingleton } from './LoggerSingleton';
import type { HavenLogger } from '@hit/logger';

export { Category as UICategory, PiiLevelEnum as UIPiiLevelEnum } from '@hit/logger/dist/lib/ui-logger';

export class UILoggerSingleton extends CPLogger {
  static _instances: HavenUILogger;
  static _app: string;

  private constructor() {
    super();
  }

  static getInstance(defaultEnv: string = 'development'): HavenUILogger | HavenLogger {
    if (!UILoggerSingleton.isRunningInBrowser()) {
      return LoggerSingleton.getInstance();
    }

    if (!UILoggerSingleton._instances) {
      const amorphicBrowserConfig = (window as any).amorphic.config;
      const uiConfig: UIConfig = {
        level: 'info',
        appVersion: version,
        environment: amorphicBrowserConfig.environment ?? defaultEnv,
        app: amorphicBrowserConfig.application ?? 'coverpath',
        sendToServer: true,
        serverURL: UILoggerSingleton.defineServerURL(),
      };

      const logger = new UILogger(uiConfig).getSystemLogger();
      this._app = uiConfig.app;
      const childLogger = logger.childLogger({
        error: {
          isHumanRelated: false,
        },
      });

      UILoggerSingleton._instances = childLogger;
    }

    return UILoggerSingleton._instances;
  }

  private static defineServerURL() {
    if (UILoggerSingleton.isRunningInBrowser()) {
      return window.location.origin;
    }
    return '';
  }
}
